<div class="checkbox"
     [ngClass]="{
        'predefined-value': predefinedStyleEnabled,
        'checkbox--checked': checkbox.checked,
        'checkbox--expand-inline': expandInline
        }">
    <div class="desc-icon">
        <app-tooltip-icon *ngIf="fieldConfig.description!=undefined"
                          [outlined]="fieldConfig.tooltipIconOutlined"
                          [theme]="fieldConfig.tooltipTheme"
                          [description]="fieldConfig.description">
        </app-tooltip-icon>
    </div>

    <div class="checkbox-element"
         (click)="onClick($event)"
         [ngClass]="{'checkbox-element--with-icon': checkboxConfig.icon, 'checkbox-element--hidden-disabled': checkboxConfig.disableVisualChangesOnDisabled }"
    >
    <mat-checkbox color="primary"
                      [ngClass]="readonlyConfig === false ? 'show-checkbox' : 'hide-checkbox'"
                      [id]="id"
                      #checkbox
                      matInput
                      (change)="onChange($event)"
                      [formControl]="control"
        >

        </mat-checkbox>
        <div class="checkbox-element__caption"
             [ngClass]="{
                'checkbox-element__caption--clickable': checkboxConfig.clickableLabel && !checkboxConfig.disableVisualChangesOnDisabled,
                'checkbox-element__caption--with-count': hasCaptionCount
                }">

            <div class="checkbox-element__icon-wrapper"
                 *ngIf="checkboxConfig.icon"
                 (click)="toggleValue()">
                <img *ngIf="!showIconChecked" class="checkbox-element__icon" [src]="checkboxConfig.icon">
                <img *ngIf="showIconChecked" class="checkbox-element__icon" [src]="checkboxConfig.iconChecked">
            </div>

            <div class="checkbox-element__caption__text" *ngIf="fieldConfig.caption" (click)="toggleValue()">
                {{ fieldConfig.caption | translate: checkboxConfig.translateLabel }}
                <div *ngIf="hasCaptionCount"
                      class="checkbox-element__caption__text__count">
                    ({{fieldConfig.captionCount}})
                </div>
                <div *ngIf="checkboxConfig.expand" class="expand_text" (click)="toggleText()">
                    {{ (expandText ?
                    checkboxConfig.expand.collapsedLabel:
                    checkboxConfig.expand.expandedLabel) | translate
                    }}

                </div>
                <!--<mat-icon class="expand_text__icon"> {{expandText ? 'expand_less' : 'expand_more'}}</mat-icon>-->
                <div *ngIf="expandText" class="text-grey expand-text">
                    {{ checkboxConfig.expand.expandText }}
                </div>
            </div>

            <div *ngIf="fieldConfig.captionAsHTML">
                <div [innerHTML]="captionAsHTML | safeHtml"></div>
                <ng-container *ngIf="ellipsisVisible">...</ng-container>
                <div *ngIf="expandTextVisible">&nbsp;</div>
                <div *ngIf="expandTextVisible" class="expand_text" (click)="toggleText()">
                    {{ (expandText ?
                    checkboxConfig.expand.collapsedLabel:
                    checkboxConfig.expand.expandedLabel) | translate
                    }}

                </div>
                <!--<mat-icon class="expand_text__icon"> {{expandText ? 'expand_less' : 'expand_more'}}</mat-icon>-->
                <div *ngIf="!expandInline && expandText" class="text-grey expand-text"
                     [innerHTML]="checkboxConfig.expand.expandText | safeHtml"></div>
            </div>

            <mat-error class="checkbox-error" *ngIf="!checkbox.checked && errorsMap.get(fieldConfig.fieldKey)">{{
                (context + '.' + fieldConfig.fieldKey + '.' +
                errorsMap.get(fieldConfig.fieldKey))|translate}}
            </mat-error>
        </div>
    </div>
    <div class="desc-icon">
        <app-information-icon class="information-icon reset-position" *ngIf="informationIconVisible"
                              [information]="this.fieldConfig.predefined.additionalInfo | additionalInfo"
                              [description]="fieldConfig.description | translate">
        </app-information-icon>
    </div>
</div>
